import { Dispatch, MiddlewareAPI } from '@reduxjs/toolkit';
import { trackAddMetricAction } from '@/middlewares/userActionsMiddleware/trackAddMetricAction';
import { getTrackedDatasourceId } from '@/hooks';
import { trackAddDimensionAction } from './trackAddDimensionAction';
import { trackChangeDimensionAction } from './trackChangeDimensionAction';
import { trackSummarizeStepCompleteAction } from './trackSummarizeStepCompleteAction';
import { UserActionPayload } from './types';

const actionTrackers = [
  trackAddMetricAction,
  trackAddDimensionAction,
  trackChangeDimensionAction,
  trackSummarizeStepCompleteAction,
];

export const userActionsMiddleware =
  (store: MiddlewareAPI) => (next: Dispatch) => (action: UserActionPayload) => {
    const datasourceId = getTrackedDatasourceId();
    actionTrackers.forEach((track) => track(store, action, datasourceId));

    return next(action);
  };
